import { Box, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { ReactNode } from "react";
import CzystaBydgoszczLogo from "../../../components/CzystaBydgoszczLogo";
import { Logo } from "../Logo";
import { TrashScheduleModel } from "../models/TrashScheduleModel";

interface TitleForTableProps {
  data: TrashScheduleModel;
  button?: ReactNode;
}

const TitleForTable = ({ data, button }: TitleForTableProps) => {
  return (
    <Stack spacing={0}>
      <Box
        sx={(theme) => ({
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          [theme.breakpoints.down("sm")]: {
            flexWrap: "wrap",
          },
        })}
      >
        <Typography variant="h4" component="h1">
          {" "}
          Harmonogram odbioru odpadów komunalnych dla nieruchomości:
        </Typography>
        {button}
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          flexWrap: "wrap",
          py: 2,
        }}
      >
        <Box sx={{ flexGrow: 1, flexShrink: 0 }}>
          <Typography>
            <Typography component="span" sx={{ fontWeight: "bold" }}>
              Miasto:{" "}
            </Typography>
            {data.city} - okręg: {data.area}
          </Typography>
          <Typography>
            <Typography component="span" sx={{ fontWeight: "bold" }}>
              Ulica i numer:{" "}
            </Typography>
            {data.street} {data.buildingNumber}{" "}
          </Typography>
          <Typography>
            <Typography component="span" sx={{ fontWeight: "bold" }}>
              Typ nieruchomości:{" "}
            </Typography>
            {data.buildingType ? `${data.buildingType}` : "brak informacji"}{" "}
            {data.name ? `(${data.name})` : ""}
          </Typography>
        </Box>
        <Box
          aria-hidden="true"
          sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}
        >
          <Box sx={{ minWidth: 100, maxWidth: 100 }}>
            <Logo />
          </Box>
          <Box sx={{ minWidth: 100, maxWidth: 100 }}>
            <CzystaBydgoszczLogo />
          </Box>
        </Box>
      </Box>
    </Stack>
  );
};

export default TitleForTable;
